import correct from '@/assets/img/documents/ac.jpg';
import wrong from '@/assets/img/documents/ac-wrong.jpg';
import Card from '@/components/Card';
import { Uploader } from '@/components/ui/Uploader/Uploader';
import { ATTACHMENT_TYPES } from '@/consts';

import { useLingui } from '@lingui/react';

export const AC_POLICY_NAME = 'ac_policy';

const ACPolicy = () => {
  const { i18n } = useLingui();

  const instructionProps = {
    title: i18n.t('Jak poprawnie dodać polisę AC?'),
    steps: [
      i18n.t('Upewnij się, że wszystkie dane pojazdu są widoczne.'),
      <span key="all-pages" className="font-bold text-red-400">
        {i18n.t('Sprawdź, czy załączasz wszystkie strony polisy.')}
      </span>,
      i18n.t('Jeśli przesyłasz zdjęcia – sprawdź, czy dokument jest czytelny.'),
    ],
    correctImg: correct,
    wrongImg: wrong,
  };

  return (
    <Card>
      <Uploader
        title={i18n.t('Polisa AC ważna na dzień zdarzenia')}
        instructionProps={instructionProps}
        inputFieldName={AC_POLICY_NAME}
        required
        attachmentTypeId={ATTACHMENT_TYPES.POLISA_AC}
      />
    </Card>
  );
};

export default ACPolicy;
